import type { Mention } from "@circle-react-shared/uikit/TipTap/Extensions/CustomExtensions/Mentions/MentionsDisplay/types";
import { NodeViewWrapper } from "@tiptap/react";

import { ProfileHoverCard } from "@/react/components/Profile/HoverCard";

import { EntityMentionChip } from "../EntityMentionChip";
import type { SgidNodeViewProps } from "../types";
import { useSgidObject } from "../useSgidObject";
import { getMentionHref, isGroupMention } from "./helpers";

export const CircleAiMentionDisplay = ({ node }: SgidNodeViewProps) => {
  const mention = useSgidObject<Mention>(node.attrs.sgid);

  if (!mention) return null;

  return (
    <NodeViewWrapper as="span">
      <ProfileHoverCard
        communityMemberId={mention.id}
        name={mention.name}
        publicUid={mention.public_uid}
        headline={mention.headline}
        avatarURL={mention.avatar_url}
        side="top"
        sideOffset={10}
        disabled={isGroupMention(mention.type)}
      >
        <EntityMentionChip
          prefix="@"
          label={mention.name}
          href={getMentionHref(mention)}
        />
      </ProfileHoverCard>
    </NodeViewWrapper>
  );
};
